import type { LocalizedCopy } from "../productCopyTypes";

function paragraphs(text: string): string {
  return text
    .split(/\n\n+/)
    .map((p) => p.trim())
    .filter(Boolean)
    .map((p) => `<p>\n${p}\n</p>`)
    .join("\n\n");
}

function featureList(items: string[]): string {
  return `<ul>\n${items.map((item) => `  <li>${item}</li>`).join("\n")}\n</ul>`;
}

const COPY = {
  en: {
    title: "Car Series",
    description:
      "Bring the excitement of high-performance automobiles to your collection with the 12GO 95006 Car Series. This exciting building set includes three highly detailed sports cars inspired by the world of modern performance vehicles. Built from 1,216 high-quality building pieces, the set offers an enjoyable building experience while creating an impressive collection of display models.\n\nEach vehicle features its own distinctive styling, authentic bodywork, aerodynamic spoilers, racing-inspired details, and realistic proportions. The set includes a white performance coupe with blue racing stripes, an orange sports coupe with an aggressive appearance, and a bright green modern performance car, giving builders three unique models in a single package.\n\nDesigned with great attention to detail, every car features a detailed cockpit, realistic wheels, custom body panels, and performance-inspired accessories. The compact scale makes them ideal for display on a desk, shelf, or alongside other brick-built vehicle collections.\n\nWhether you're a fan of sports cars, automotive design, or simply enjoy building detailed vehicle models, the 12GO 95006 Car Series delivers a rewarding building experience and an eye-catching display set. Compatible with building bricks from other major brands, it makes an excellent addition to any collection.",
    highlightsTitle: "Key Features",
    features: [
      "1,216 high-quality building pieces",
      "Includes three detailed sports cars in one set",
      "Modern sports car designs with aerodynamic spoilers",
      "Detailed interiors with realistic cockpit features",
      "Unique styling for each vehicle",
      "Excellent display models for automotive collections",
      "Compatible with building bricks from other major brands",
      "Perfect for car enthusiasts, collectors, and experienced builders",
      "Great gift for sports car fans",
      "Designed for builders aged 14+",
    ],
    specsTitle: "Product Features",
    specs: [
      "<li><strong>Brand:</strong> 12GO</li>",
      "<li><strong>Model:</strong> Car Series</li>",
      "<li><strong>Item Number:</strong> 95006</li>",
      "<li><strong>Piece Count:</strong> 1216+ pieces</li>",
      "<li><strong>Recommended Age:</strong> 14+</li>",
    ],
  },
  pl: {
    title: "Car Series",
    description:
      "Wzbogać swoją kolekcję o trzy wyjątkowe samochody sportowe dzięki zestawowi 12GO 95006 Car Series. Ten atrakcyjny zestaw zawiera trzy szczegółowo wykonane modele inspirowane światem nowoczesnych samochodów o wysokich osiągach. Składający się z 1216 wysokiej jakości elementów komplet zapewnia satysfakcjonującą budowę oraz efektowne modele kolekcjonerskie.\n\nKażdy samochód wyróżnia się własnym, niepowtarzalnym stylem. W zestawie znajduje się biały sportowy coupe z charakterystycznymi niebieskimi pasami wyścigowymi, pomarańczowe sportowe coupe o dynamicznej stylistyce oraz zielony nowoczesny samochód sportowy. Dzięki temu jeden zestaw pozwala zbudować trzy różnorodne modele.\n\nKażdy pojazd został zaprojektowany z dużą dbałością o szczegóły. Modele posiadają realistycznie odwzorowane wnętrza, sportowe spojlery, aerodynamiczne elementy nadwozia, charakterystyczne felgi oraz liczne detale podkreślające ich sportowy charakter. Kompaktowe rozmiary sprawiają, że doskonale prezentują się na półce, biurku lub w kolekcji modeli samochodów z klocków.\n\nNiezależnie od tego, czy jesteś fanem samochodów sportowych, motoryzacji czy po prostu lubisz budować realistyczne modele z klocków, 12GO 95006 Car Series zapewni wiele godzin satysfakcjonującej zabawy i stanie się efektowną ozdobą każdej kolekcji. Zestaw jest kompatybilny z klockami innych popularnych producentów.",
    highlightsTitle: "Cechy produktu",
    features: [
      "1216 wysokiej jakości elementów",
      "Trzy szczegółowo wykonane samochody sportowe w jednym zestawie",
      "Nowoczesne sportowe nadwozia z aerodynamicznymi spojlerami",
      "Realistycznie odwzorowane wnętrza z kokpitami",
      "Unikalny wygląd każdego modelu",
      "Doskonałe modele ekspozycyjne dla kolekcjonerów motoryzacji",
      "Kompatybilność z klockami innych popularnych producentów",
      "Idealny dla fanów motoryzacji, kolekcjonerów i doświadczonych konstruktorów",
      "Świetny pomysł na prezent dla miłośników samochodów sportowych",
      "Przeznaczony dla konstruktorów od 14. roku życia",
    ],
    specsTitle: "Cechy zestawu",
    specs: [
      "<li><strong>Marka:</strong> 12GO</li>",
      "<li><strong>Model:</strong> Car Series</li>",
      "<li><strong>Numer katalogowy:</strong> 95006</li>",
      "<li><strong>Liczba elementów:</strong> 1216+</li>",
      "<li><strong>Wiek zalecany:</strong> 14+</li>",
    ],
  },
  de: {
    title: "Car Series",
    description:
      "Erweitern Sie Ihre Sammlung mit drei beeindruckenden Sportwagen aus dem 12GO 95006 Car Series Set. Dieses hochwertige Klemmbaustein-Set enthält drei detailreiche Sportwagen, inspiriert von der Welt moderner Hochleistungsfahrzeuge. Mit 1.216 hochwertigen Bausteinen bietet das Set ein anspruchsvolles Bauerlebnis und gleichzeitig drei attraktive Ausstellungsmodelle.\n\nJedes Fahrzeug besitzt seinen eigenen unverwechselbaren Charakter. Das Set umfasst ein weißes Sportcoupé mit markanten blauen Rennstreifen, ein orangefarbenes Sportcoupé mit dynamischem Design sowie einen auffälligen grünen modernen Sportwagen. Dadurch entstehen drei einzigartige Modelle in einem einzigen Set.\n\nAlle Fahrzeuge wurden mit großer Liebe zum Detail gestaltet. Sie verfügen über realistische Cockpits, sportliche Heckspoiler, aerodynamische Karosserieelemente, detaillierte Felgen sowie zahlreiche Designelemente, die ihren sportlichen Charakter unterstreichen. Dank ihres kompakten Maßstabs eignen sich die Modelle hervorragend als Dekoration auf Schreibtisch, Regal oder in einer Fahrzeugsammlung.\n\nGanz gleich, ob Sie Sportwagen, Automobildesign oder detailreiche Klemmbausteinmodelle lieben – die 12GO 95006 Car Series bietet ein unterhaltsames Bauerlebnis und beeindruckende Modelle für jede Sammlung. Das Set ist zudem mit Klemmbausteinen anderer führender Hersteller kompatibel.",
    highlightsTitle: "Produktmerkmale",
    features: [
      "1.216 hochwertige Klemmbausteine",
      "Drei detaillierte Sportwagen in einem Set",
      "Moderne Sportwagendesigns mit aerodynamischen Heckspoilern",
      "Detaillierte Innenräume mit realistischen Cockpits",
      "Individuelles Design für jedes Fahrzeug",
      "Hervorragende Ausstellungsmodelle für Automobilsammlungen",
      "Kompatibel mit Klemmbausteinen anderer führender Hersteller",
      "Ideal für Autoenthusiasten, Sammler und erfahrene Baumeister",
      "Perfektes Geschenk für Sportwagenfans",
      "Empfohlen ab 14 Jahren",
    ],
    specsTitle: "Produkteigenschaften",
    specs: [
      "<li><strong>Marke:</strong> 12GO</li>",
      "<li><strong>Modell:</strong> Car Series</li>",
      "<li><strong>Artikelnummer:</strong> 95006</li>",
      "<li><strong>Teileanzahl:</strong> 1216+</li>",
      "<li><strong>Empfohlenes Alter:</strong> 14+</li>",
    ],
  },
  es: {
    title: "Car Series",
    description:
      "Amplía tu colección con tres espectaculares deportivos gracias al 12GO 95006 Car Series. Este completo set de construcción incluye tres detallados coches deportivos inspirados en el mundo de los automóviles de alto rendimiento. Con 1.216 piezas de alta calidad, ofrece una experiencia de construcción entretenida y tres impresionantes modelos para exhibición.\n\nCada vehículo presenta un diseño único. El set incluye un deportivo blanco con llamativas franjas azules de competición, un coupé deportivo naranja de aspecto agresivo y un moderno deportivo verde brillante. De esta manera, un solo set permite construir tres modelos completamente diferentes.\n\nCada automóvil ha sido diseñado con una gran atención al detalle. Los modelos incorporan interiores realistas, alerones deportivos, elementos aerodinámicos, llantas detalladas y numerosos detalles inspirados en los vehículos de altas prestaciones. Su tamaño compacto los convierte en piezas ideales para exponer en un escritorio, una estantería o junto a otras colecciones de vehículos de bloques.\n\nTanto si eres un apasionado de los coches deportivos como del diseño automovilístico o simplemente disfrutas construyendo modelos detallados, el 12GO 95006 Car Series ofrece una experiencia de construcción muy satisfactoria y un magnífico conjunto de exhibición. Además, es compatible con bloques de construcción de otras marcas populares.",
    highlightsTitle: "Características",
    features: [
      "1.216 piezas de alta calidad",
      "Incluye tres detallados coches deportivos",
      "Diseños modernos con alerones aerodinámicos",
      "Interiores detallados con cabinas realistas",
      "Diseño exclusivo para cada vehículo",
      "Excelentes modelos para exhibición",
      "Compatible con bloques de construcción de otras marcas populares",
      "Ideal para aficionados al automóvil, coleccionistas y constructores experimentados",
      "Un regalo perfecto para los amantes de los coches deportivos",
      "Recomendado para mayores de 14 años",
    ],
    specsTitle: "Características del producto",
    specs: [
      "<li><strong>Marca:</strong> 12GO</li>",
      "<li><strong>Modelo:</strong> Car Series</li>",
      "<li><strong>Número de artículo:</strong> 95006</li>",
      "<li><strong>Piezas:</strong> 1216+</li>",
      "<li><strong>Edad recomendada:</strong> 14+</li>",
    ],
  },
  fr: {
    title: "Car Series",
    description:
      "Complétez votre collection avec trois superbes voitures de sport grâce au 12GO 95006 Car Series. Cet ensemble de construction comprend trois modèles sportifs richement détaillés, inspirés de l'univers des automobiles hautes performances. Composé de 1 216 pièces de haute qualité, il offre une expérience de construction passionnante ainsi que trois magnifiques modèles d'exposition.\n\nChaque véhicule possède son propre style distinctif. L'ensemble comprend un coupé sportif blanc orné de bandes de course bleues, un coupé sportif orange au design dynamique ainsi qu'une sportive moderne verte aux lignes agressives. Ce coffret permet ainsi de construire trois modèles totalement différents.\n\nChaque voiture bénéficie d'une conception particulièrement soignée. Les modèles disposent d'intérieurs réalistes, d'ailerons sportifs, d'éléments de carrosserie aérodynamiques, de jantes détaillées et de nombreux éléments qui soulignent leur caractère sportif. Leur format compact en fait des pièces idéales pour être exposées sur un bureau, une étagère ou dans une collection de véhicules en briques.\n\nQue vous soyez passionné d'automobiles sportives, amateur de design automobile ou simplement adepte des modèles détaillés à construire, le 12GO 95006 Car Series vous offrira une expérience de construction agréable ainsi qu'un superbe ensemble de collection. Il est également compatible avec les briques de construction des principales marques.",
    highlightsTitle: "Caractéristiques",
    features: [
      "1 216 pièces de haute qualité",
      "Trois voitures de sport détaillées dans un seul coffret",
      "Designs modernes avec ailerons aérodynamiques",
      "Intérieurs détaillés avec cockpits réalistes",
      "Style unique pour chaque véhicule",
      "Superbes modèles d'exposition pour les collectionneurs",
      "Compatible avec les briques des principales marques",
      "Idéal pour les passionnés d'automobile, les collectionneurs et les constructeurs expérimentés",
      "Une excellente idée de cadeau pour les amateurs de voitures de sport",
      "Recommandé à partir de 14 ans",
    ],
    specsTitle: "Caractéristiques du produit",
    specs: [
      "<li><strong>Marque :</strong> 12GO</li>",
      "<li><strong>Modèle :</strong> Car Series</li>",
      "<li><strong>Référence :</strong> 95006</li>",
      "<li><strong>Nombre de pièces :</strong> 1216+</li>",
      "<li><strong>Âge recommandé :</strong> 14+</li>",
    ],
  },
  nl: {
    title: "Car Series",
    description:
      "Breid je collectie uit met drie indrukwekkende sportwagens dankzij de 12GO 95006 Car Series. Deze hoogwaardige bouwset bevat drie gedetailleerde sportwagens, geïnspireerd op de wereld van moderne high-performance auto's. Met 1.216 hoogwaardige bouwstenen biedt deze set een uitdagende bouwervaring en drie prachtige modellen om tentoon te stellen.\n\nElk voertuig heeft zijn eigen unieke uitstraling. De set bevat een witte sportcoupé met opvallende blauwe racestrepen, een oranje sportcoupé met een agressief ontwerp en een felgroene moderne sportwagen. Zo kun je met één set drie totaal verschillende modellen bouwen.\n\nElke auto is ontworpen met veel aandacht voor detail. De modellen beschikken over realistisch vormgegeven interieurs, sportieve achterspoilers, aerodynamische carrosserie-elementen, gedetailleerde velgen en tal van details die hun sportieve karakter benadrukken. Dankzij het compacte formaat zijn ze perfect geschikt voor een bureau, boekenplank of als onderdeel van een verzameling bouwsteenvoertuigen.\n\nOf je nu een liefhebber bent van sportwagens, autodesign of gewoon graag gedetailleerde voertuigen bouwt, de 12GO 95006 Car Series biedt urenlang bouwplezier en levert een indrukwekkende verzameling displaymodellen op. De set is bovendien compatibel met bouwstenen van andere bekende merken.",
    highlightsTitle: "Kenmerken",
    features: [
      "1.216 hoogwaardige bouwstenen",
      "Drie gedetailleerde sportwagens in één set",
      "Moderne sportwagenontwerpen met aerodynamische spoilers",
      "Gedetailleerde interieurs met realistische cockpits",
      "Uniek ontwerp voor elk voertuig",
      "Uitstekende displaymodellen voor autoverzamelaars",
      "Compatibel met bouwstenen van andere bekende merken",
      "Ideaal voor autoliefhebbers, verzamelaars en ervaren bouwers",
      "Een perfect cadeau voor liefhebbers van sportwagens",
      "Aanbevolen vanaf 14 jaar",
    ],
    specsTitle: "Productkenmerken",
    specs: [
      "<li><strong>Merk:</strong> 12GO</li>",
      "<li><strong>Model:</strong> Car Series</li>",
      "<li><strong>Artikelnummer:</strong> 95006</li>",
      "<li><strong>Aantal onderdelen:</strong> 1216+</li>",
      "<li><strong>Aanbevolen leeftijd:</strong> 14+</li>",
    ],
  },
  zh: {
    title: "Car Series",
    description:
      "使用 12GO 95006 Car Series，将三款充满激情的高性能跑车加入您的收藏。这款套装包含三辆精致的运动跑车模型，灵感源自现代高性能汽车世界。全套由1,216块高品质积木组成，不仅带来丰富有趣的拼搭体验，还能打造三款极具观赏价值的展示模型。\n\n每辆汽车都拥有独特的设计风格。套装包括一辆带有蓝色赛车条纹的白色跑车、一辆造型动感的橙色双门跑车，以及一辆充满力量感的绿色现代高性能跑车，让玩家一次即可拼搭三种风格截然不同的车型。\n\n每辆车型都经过精心设计，拥有逼真的驾驶舱、运动尾翼、空气动力学车身、精细轮毂以及丰富的细节，充分展现现代跑车的运动魅力。紧凑的尺寸使其非常适合摆放在书桌、展示架或与其他积木汽车模型一同收藏展示。\n\n无论您是跑车爱好者、汽车设计迷，还是喜欢拼搭精细车辆模型的玩家，12GO 95006 Car Series都将带来充满乐趣的拼搭体验，并成为收藏中的亮眼展示作品。同时，本产品兼容其他主流品牌积木。",
    highlightsTitle: "产品特点",
    features: [
      "1,216块高品质积木",
      "一套包含三辆精致运动跑车",
      "现代跑车设计，配备空气动力学尾翼",
      "精细还原驾驶舱内饰",
      "三款车型均拥有独特设计风格",
      "非常适合作为汽车模型收藏展示",
      "兼容其他主流品牌积木",
      "适合汽车爱好者、收藏家及资深积木玩家",
      "送给跑车爱好者的理想礼物",
      "建议年龄：14岁以上",
    ],
    specsTitle: "产品特点",
    specs: [
      "<li><strong>品牌：</strong>12GO</li>",
      "<li><strong>型号：</strong>Car Series</li>",
      "<li><strong>货号：</strong>95006</li>",
      "<li><strong>颗粒数：</strong>1216+</li>",
      "<li><strong>建议年龄：</strong>14+</li>",
    ],
  },
  it: {
    title: "Serie di auto",
    description:
      "Porta nella tua collezione l'emozione delle automobili ad alte prestazioni con la 12GO 95006 Car Series. Questo entusiasmante set di costruzioni include tre auto sportive altamente dettagliate, ispirate al mondo delle moderne vetture ad alte prestazioni. Realizzato con 1,216 pezzi da costruzione di alta qualità, il set offre un'esperienza di assemblaggio coinvolgente e permette di creare un'impressionante collezione di modelli da esposizione.\n\nOgni veicolo presenta uno stile distintivo, carrozzeria autentica, spoiler aerodinamici, dettagli ispirati alle auto da corsa e proporzioni realistiche. Il set include una coupé sportiva bianca con strisce da gara blu, una coupé sportiva arancione dall'aspetto grintoso e una moderna auto ad alte prestazioni verde brillante, offrendo tre modelli unici in un solo set.\n\nProgettata con grande attenzione ai dettagli, ogni auto presenta un abitacolo curato, ruote realistiche, pannelli della carrozzeria personalizzati e accessori ispirati alle prestazioni. Le dimensioni compatte le rendono ideali da esporre su una scrivania, uno scaffale o accanto ad altre collezioni di veicoli costruibili.\n\nChe tu sia appassionato di auto sportive, design automobilistico o semplicemente ami costruire modelli di veicoli dettagliati, la 12GO 95006 Car Series offre un'esperienza di assemblaggio appagante e un set da esposizione di grande impatto. Compatibile con i mattoncini da costruzione di altri importanti marchi, è un'eccellente aggiunta a qualsiasi collezione.",
    highlightsTitle: "Caratteristiche principali",
    features: [
      "1,216 pezzi da costruzione di alta qualità",
      "Include tre auto sportive dettagliate in un unico set",
      "Design moderni di auto sportive con spoiler aerodinamici",
      "Interni dettagliati con abitacoli realistici",
      "Stile unico per ogni veicolo",
      "Modelli da esposizione ideali per le collezioni automobilistiche",
      "Compatibile con i mattoncini da costruzione di altri importanti marchi",
      "Perfetto per appassionati di auto, collezionisti e costruttori esperti",
      "Un ottimo regalo per gli appassionati di auto sportive",
      "Progettato per costruttori dai 14 anni in su",
    ],
    specsTitle: "Caratteristiche del prodotto",
    specs: [
      "<li><strong>Marca:</strong> 12GO</li>",
      "<li><strong>Modello:</strong> Car Series</li>",
      "<li><strong>Numero articolo:</strong> 95006</li>",
      "<li><strong>Numero di pezzi:</strong> 1216+ pezzi</li>",
      "<li><strong>Età consigliata:</strong> 14+</li>",
    ],
  },
  ru: {
    title: "Серия автомобилей",
    description:
      "Добавьте в свою коллекцию атмосферу высокопроизводительных автомобилей с набором 12GO 95006 Car Series. Этот увлекательный конструктор включает три детализированных спортивных автомобиля, вдохновлённых современными спортивными машинами. В наборе 1,216 качественных деталей, которые обеспечивают увлекательный процесс сборки и позволяют создать впечатляющую коллекцию моделей для демонстрации.\n\nКаждая модель отличается уникальным дизайном, реалистичным кузовом, аэродинамическими спойлерами, деталями в гоночном стиле и правдоподобными пропорциями. В набор входят белое спортивное купе с синими гоночными полосами, оранжевое купе с агрессивным обликом и ярко-зелёный современный автомобиль с высокими характеристиками — три уникальные модели в одном наборе.\n\nКаждый автомобиль разработан с большим вниманием к деталям и оснащён проработанным салоном, реалистичными колёсами, индивидуальными кузовными панелями и аксессуарами в стиле высоких скоростей. Компактный размер делает модели идеальными для размещения на столе, полке или рядом с другими коллекциями автомобилей из конструктора.\n\nЕсли вы увлекаетесь спортивными автомобилями, автомобильным дизайном или просто любите собирать детализированные модели техники, 12GO 95006 Car Series подарит увлекательный процесс сборки и эффектный набор для демонстрации. Набор совместим с конструкторами других крупных брендов и станет отличным дополнением к любой коллекции.",
    highlightsTitle: "Основные характеристики",
    features: [
      "1,216 качественных деталей конструктора",
      "В одном наборе три детализированных спортивных автомобиля",
      "Современный дизайн спортивных автомобилей с аэродинамическими спойлерами",
      "Детализированные интерьеры с реалистичными элементами кокпита",
      "Уникальный стиль каждой модели",
      "Отличные модели для демонстрации в автомобильных коллекциях",
      "Совместимость с конструкторами других крупных брендов",
      "Идеальный выбор для автолюбителей, коллекционеров и опытных сборщиков",
      "Отличный подарок для поклонников спортивных автомобилей",
      "Предназначен для сборщиков от 14 лет",
    ],
    specsTitle: "Характеристики товара",
    specs: [
      "<li><strong>Бренд:</strong> 12GO</li>",
      "<li><strong>Модель:</strong> Car Series</li>",
      "<li><strong>Номер товара:</strong> 95006</li>",
      "<li><strong>Количество деталей:</strong> 1216+ деталей</li>",
      "<li><strong>Рекомендуемый возраст:</strong> 14+</li>",
    ],
  },

} as const;

type LocaleKey = keyof typeof COPY;

function buildLocaleHtml(locale: LocaleKey): string {
  const c = COPY[locale] ?? COPY.en;
  return `<h1>${c.title}</h1>

${paragraphs(c.description)}

<h2>${c.specsTitle}</h2>

<ul>
${c.specs.join("\n")}
</ul>

<h2>${c.highlightsTitle}</h2>

${featureList([...c.features])}`;
}

export const RICH_PRODUCT_COPY_95006: LocalizedCopy = {
  en: buildLocaleHtml("en"),
  pl: buildLocaleHtml("pl"),
  de: buildLocaleHtml("de"),
  es: buildLocaleHtml("es"),
  fr: buildLocaleHtml("fr"),
  nl: buildLocaleHtml("nl"),
  zh: buildLocaleHtml("zh"),
  it: buildLocaleHtml("it"),
  ru: buildLocaleHtml("ru"),
};
